<template>
	
		<div class="toolbar" style="border:2px solid #eee;background:#f5f7fa">
			<div class="flooter">
				<!-- 原本代码 -->
				<span v-for="(bar,index) in items" :class=bar.class :key=index @click=onEmitEvent(bar.click)><i class="iconfont" v-html="bar.iconfont"></i>{{bar.name}}</span>
				<slot name="appendbuttons"></slot>
			</div>       	
		</div>
	
</template> 

<script> 
export default{
	props:{		
		items:{
			Type:Array,
			default(){
			   return []
			}
		}
	},
	methods:{
		onEmitEvent(eventName){
			this.$emit(eventName);
		}
	}
}
</script>

<style>
  
</style>